import React from 'react'
import styled, { css } from 'styled-components'

export interface SortedByRelevanceProps {
  className?: string
}

const SortedByRelevance: React.FC<SortedByRelevanceProps> = ({ className }) => {
  return <div className={className}>SORTED BY RELEVANCE</div>
}

const StyledSortedByRelevance = styled(SortedByRelevance)(
  ({ theme }) => css`
    display: flex;
    align-items: center;
    justify-content: flex-end;
    flex: 0 0 50%;
    background-color: ${theme.colors.grayscale.white};
    height: 60px;
    margin-bottom: 0;
    padding-right: 15px;
    text-transform: uppercase;
    font-size: 14px;
    line-height: 16px;
    font-family: ${theme.fontFamilies.robotoCondensed};
    @media (min-width: 992px) {
      background-color: transparent;
      flex: 0 0 270px;
      padding-right: 80px;
    }
  `,
)

export default StyledSortedByRelevance
